module.exports = __webpack_public_path__ + "assets/roboto-latin-500.woff";